import { OtterAPIAppRow } from '../components/OtterAPIAppRow';
import type { AppRow } from '../type/AppRow';

export const otterAPIAppRow: AppRow = {
  key: 'otter_api',
  name: 'Otter API',
  AppComponent: OtterAPIAppRow,
};
